import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class CreateCustomerOnboardingErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [{
                'code': 'duplicated_taxpayer_identification_number',
                'text': 'An customer onboarding request already exists for this taxpayer identification number',
            }]
        }
    }

    static errorCodes() {
        return ['customer_onboarding_customer_already_exists', 'duplicated_taxpayer_identification_number'];
    }
}